{
  "name": "certemy",
  "version": "112.17.0",
  "license": "MIT",
  "angular-cli": {},
  "type": "module",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:dev": "NODE_OPTIONS=--openssl-legacy-provider ng serve",
    "start_no_reload": "ng serve --live-reload false",
    "start_local": "ng serve --host 0.0.0.0 --disableHostCheck true",
    "build": "node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build",
    "build:dev": "npm run build -- --configuration=dev",
    "stats-build": "npm run build -- --stats-json",
    "bundle-report": "npm run stats-build && webpack-bundle-analyzer dist/stats.json",
    "format": "prettier \"*(src|e2e)/**/*.{ts,scss,html}\"",
    "format:write": "npm run format -- --write",
    "format:check": "npm run format -- --list-different",
    "format:staged": "lint-staged",
    "lint": "ng lint",
    "test": "ng test",
    "test:ci": "ng test --watch=false",
    "test:browser": "ng test --configuration=browser",
    "test:browser:ci": "ng test --watch=false --configuration=browser-headless",
    "e2e": "ng e2e --devServerTarget=''",
    "prepare": "husky",
    "test:date-characterization": "npm run test:ci -- --include='src/app/services/datepicker-formatter/**/*.spec.ts' --include='src/app/pages/organization/management/verification-search-psv/acquisition-request-tracking-history-modal/acquisition-request-tracking.helpers.spec.ts'"
  },
  "private": true,
  "dependencies": {
    "@almothafar/angular-signature-pad": "^10.0.0",
    "@angular/cdk": "^22.2.3",
    "@angular/common": "^22.2.3",
    "@angular/core": "^22.2.3",
    "@angular/forms": "^22.2.3",
    "@angular/platform-browser": "^22.2.3",
    "@angular/router": "^22.2.3",
    "@bluehalo/ngx-leaflet": "^22.0.0",
    "@ctrl/ngx-codemirror": "^7.0.0",
    "@maskito/angular": "^5.6.0",
    "@maskito/core": "^5.6.0",
    "@maskito/kit": "^5.6.0",
    "@ng-bootstrap/ng-bootstrap": "^21.0.0",
    "@ngrx/component": "^22.0.1",
    "@ngrx/component-store": "^22.0.1",
    "@ngrx/effects": "^22.0.1",
    "@ngrx/entity": "^22.0.1",
    "@ngrx/operators": "^22.0.1",
    "@ngrx/router-store": "^22.0.1",
    "@ngrx/store": "^22.0.1",
    "@ngrx/store-devtools": "^22.0.1",
    "@noble/hashes": "^2.4.0",
    "@popperjs/core": "^2.11.8",
    "@sentry/angular": "^11.8.0",
    "@swimlane/dragula": "^3.8.0",
    "angular-cropperjs": "^14.0.1",
    "bootstrap": "^5.3.8",
    "buffer": "^6.0.3",
    "card": "^2.3.0",
    "casbin": "5.39.0",
    "certemy-shared": "bitbucket:HBerger/certemy_shared_web#e50fcf1bd20887812e9f54b5e4710dd59d1e589b",
    "chart.js": "^4.4.2",
    "codemirror": "^5.65.20",
    "color": "^5.0.2",
    "cropperjs": "^1.6.2",
    "css-vars-ponyfill": "^2.4.7",
    "dayjs": "^1.11.23",
    "diff2html": "^3.4.45",
    "file-saver-es": "^2.0.5",
    "font-awesome": "^4.7.0",
    "immer": "^10.1.3",
    "interactjs": "^1.10.26",
    "jwt-decode": "^4.0.0",
    "konva": "^10.0.2",
    "leaflet": "^1.9.4",
    "lodash-es": "^4.18.1",
    "mixpanel-browser": "^2.71.0",
    "ng2-charts": "^11.0.0",
    "ngrx-store-localstorage": "^20.1.0",
    "ngx-color": "^10.1.0",
    "ngx-cookie-service": "^22.0.0",
    "ngx-doc-viewer": "^22.0.2",
    "ngx-quill": "^31.0.1",
    "object-hash": "^3.0.0",
    "print-js": "1.6.0",
    "quill": "2.0.0",
    "rxjs": "7.8.2",
    "tslib": "^2.8.1",
    "util": "^0.12.5",
    "zone.js": "^0.16.3"
  },
  "devDependencies": {
    "@angular-eslint/builder": "22.6.0",
    "@angular-eslint/eslint-plugin": "22.6.0",
    "@angular-eslint/eslint-plugin-template": "22.6.0",
    "@angular-eslint/schematics": "22.6.0",
    "@angular-eslint/template-parser": "22.6.0",
    "@angular/build": "22.2.3",
    "@angular/cli": "^22.2.3",
    "@angular/compiler": "^22.2.3",
    "@angular/compiler-cli": "^22.2.3",
    "@angular/language-service": "^22.2.3",
    "@angular/localize": "^22.2.3",
    "@eslint/js": "^10.0.1",
    "@types/file-saver-es": "^2.0.3",
    "@types/leaflet": "^1.9.8",
    "@types/lodash-es": "^4.17.12",
    "@types/mixpanel": "~2.14.0",
    "@types/node": "^24.19.2",
    "@vitest/browser-playwright": "^5.0.5",
    "angular-eslint": "22.6.0",
    "eslint": "^10.13.0",
    "husky": "^9.1.7",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-marbles": "^0.9.2",
    "jsdom": "^30.1.3",
    "lint-staged": "^17.6.0",
    "ng-packagr": "^22.2.4",
    "playwright": "^1.64.1",
    "prettier": "^3.6.2",
    "ts-node": "~10.9.2",
    "typescript": "6.0.3",
    "typescript-eslint": "^8.72.0",
    "vitest": "^5.0.5"
  }
}
